// This function converts date object values (as saved in the form) to yyyy-mm-dd strings. It only uses the number
// values and doesn't use built in JS date object or ISO string so avoids timezone pitfalls. The output can be used
// used with dayjs, which likes this format.

export function DateObjectToYYYMMDDstring(dateObject: {
  day: number;
  month: number;
  year: number;
}): string {
  if (dateObject?.day && dateObject?.month && dateObject?.year) {
    return `${dateObject.year}-${String(dateObject.month).padStart(
      2,
      '0'
    )}-${String(dateObject.day).padStart(2, '0')}`;
  }
  return '';
}
